import { render, staticRenderFns } from "./Frida.vue?vue&type=template&id=9ba1b5ca&scoped=true&"
import script from "./Frida.vue?vue&type=script&lang=js&"
export * from "./Frida.vue?vue&type=script&lang=js&"
import style0 from "./Frida.vue?vue&type=style&index=0&id=9ba1b5ca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ba1b5ca",
  null
  
)

export default component.exports